export const validate = (value, enumClass) => {
	if(typeof enumClass !== 'object') {
		throw new Error(`Enum Object is invalid! ${enumClass}`);
	}
	
	if(Object.values(enumClass).indexOf(value) === -1) {
		throw new Error(`Invalid value ${value} for Enum Object ${enumClass}`);
	}
};

export default {
	validate
};
